import { gql } from 'apollo-boost'

const VALIDATE_SCRAPING_SESSION = gql`
  mutation validateScrapingSession($id: ID!) {
    validateScrapingSession(id: $id) {
      id
      validationStatus
      validatedAt
    }
  }
`

export default VALIDATE_SCRAPING_SESSION
